import Collapse from 'react-css-collapse'

import styled, { css } from 'styled-components'
import themeGet from '@styled-system/theme-get'

import { Flex, Icon } from 'Components/UI/_Legacy'

import angleDownGlyph from 'Assets/_Legacy/Svg/angle-down.svg'

export const Container = styled(Flex).attrs({
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  mb: 5,
})`
  border-radius: 8px;
  border: solid 1px ${themeGet('colors.softPeach')};
  background-color: ${themeGet('colors.white')};
`

const headerOpenedCss = ({ opened }) =>
  opened &&
  css`
    border-bottom: solid 1px ${themeGet('colors.softPeach')};
  `
export const Header = styled(Flex).attrs({
  width: 1,
  justifyContent: 'space-between',
  alignItems: 'center',
  px: 7,
  py: 5,
})`
  cursor: pointer;

  ${headerOpenedCss};
`

export const StyledCollapse = styled(Collapse).attrs({
  className: 'collapse-transition',
})`
  width: 100%;
  border-top: 1px solid ${themeGet('colors.white')};
  transition: all 0.3s;
  border-top-color: ${({ isOpen }) =>
    isOpen &&
    css`
      ${themeGet('colors.gallery')}
    `};
`

const arrowOpenedCss = ({ opened }) =>
  opened &&
  css`
    fill: ${themeGet('colors.red')};
    transform: rotate(180deg);
  `
export const Arrow = styled(Icon).attrs({
  glyph: angleDownGlyph,
  size: 24,
})`
  cursor: pointer;
  text-decoration: none;
  transition: transform ${themeGet('transitionTime')}
    cubic-bezier(0.4, 0, 0.2, 1);
  transform: rotate(0deg);

  ${arrowOpenedCss};
`
